<script>
   import Header from "./Header.svelte";
   import Item from "./Item.svelte";
   let width = 900;
   let y;
   $: cols = Math.max(1, Math.floor(width / 475));
   const items = [
      /*{
         header: 'null',
         subheader: '/pic1.jpg',
         text: 'null',
         size: 'big',
         type: 'img'
      },*/
      {
         header: 'Tuo autosi Pitkäänparkkiin!',
         subheader: 'Lämmin ja katettu säilytystila talven ajaksi',
         text: 'Halliimme mahtuu 3,4m korkea asuntoauto tai -vaunu.'
      },
      {
         header: 'Kysyttävää?',
         subheader: 'Ota yhteyttä',
         text: `<b>pitkaparkki@gmail.com</b><br>
            Simo Pitkäkoski <br>
            <b>0400169638</b><br>
            Pirjo-Liisa Ketola <br>
            <b>0400228550</b><br><br>`
      },
      {
         header: '',
         subheader: 'Yhteystiedot:',
         text: `Korpelankyläntie 13<br>
            64820 Kärjenkoski<br>
            <br>
            y-tunnus 1437356-1 <br>`
      },
      
   ]

</script>
<svelte:window bind:innerWidth={width} bind:scrollY={y}/>
<main>
   <div id='imgcontainer'>
      <img src="/pic2crop.jpg" alt="Pitkäparkki" style="transform: translate(0,{-y/2}px)">
      <h1 id='img-header' style="transform: translate(0,{-y/4}px)">Pitkäparkki</h1>
   </div>
   <div id='container' data-cols={cols} data-winheight=50em>
      {#each items as item, i }
      <div class='item {item.size == undefined ? '': item.size}'>
         <Item {...item}i={cols != 2 ? i%2 : i %4 > 0 && i%4 < 3 ? 1 : 0 }></Item>   
      </div>
      {/each}
   </div>
</main>

<style>

   main {
      position: absolute;
      padding: 0;
      width: 100%;
   }
   
   #container .high{
      grid-row: span 2;
   }
   #container .wide{
      grid-column: span 2;
   }
   #container .big{
      grid-column: span 2;
      grid-row: span 2;
   }
  
   img {
      height: 100%;
      width: 100%;
      object-fit: cover;
   }
   #imgcontainer {
      z-index: -1;
      width: 100%;
      height: 120%;
      position: fixed;
      top: 0;
   }
   #img-header {
      position: fixed;
      right: 1rem;
      top: 1rem;
   }
   #container {
      position: relative;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      grid-template-rows: repeat(auto-fit, minmax(75px, 290px));
      grid-auto-flow: dense;
      row-gap: 1em;
      column-gap: 1em;
      margin: 25em 1em 0em 1em;
      margin-top: attr(data-winheight)
   }
</style>